module.exports = __webpack_public_path__ + "static/SFUIText-Bold-0f991f59ef7c83070715ad6687c90e83.woff";